import { render, staticRenderFns } from "./MoleculeFeedSectionContentCardDesign6.vue?vue&type=template&id=2b0ebca4&"
import script from "./MoleculeFeedSectionContentCardDesign6.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedSectionContentCardDesign6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports